module.exports = __webpack_public_path__ + "img/Designlazy_macbook-mockup 4.d5c106b9.png";